var path = 'app/scripts/modules/docker/src/pipeline/trigger/selectorTemplate.html';
var html = "<docker-trigger-options command=\"vm.command\"></docker-trigger-options>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/docker/src/pipeline/trigger/selectorTemplate.html
// module id = 1153
// module chunks = 0